// extracted by mini-css-extract-plugin
export default {"container":"style_container__+Opyk","header":"style_header__1aDRl","text":"style_text__gmL7t"};